import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SocialIcons from 'components/SocialIcons';

// TODO: Replace jsdoc with proper typescript conversion.

/**
 * @typedef {Object} ContentHeaderProps
 * @property {string | import('react').ReactNode} [header] - The text to display in the header.
 * @property {string | import('react').ReactNode} [subtitle] - The text to display in the subtitle.
 */

/**
 *
 * @param {ContentHeaderProps} props
 * @returns {import('react').ReactNode}
 */
const ContentHeader = ({
  header = 'CONTENT HEADER',
  subtitle = '',
  social = false,
  line = false,
  hr = false,
  children = null,
  icon = null,
  layout = 'column',
}) => {
  const iconValues = Array.isArray(icon) ? icon : ['fas', icon];

  // Allows for different layouts. Currently only affects the positioning of the icont vs the header text. Defaults to column (original layout).
  const horizontalLayouts = ['row'];
  const verticalLayouts = ['column'];

  const headerClasses = clsx('header-box__container', {
    'header-box__container--row': horizontalLayouts.includes(layout),
    'header-box__container--column': verticalLayouts.includes(layout),
  });

  return (
    <div className="contentHeader" id="contentHeader">
      <div className={headerClasses}>
        {icon && <FontAwesomeIcon icon={iconValues} className="icon" />}
        <h3 className="global__text--title">{header}</h3>
      </div>
      {subtitle && <h6 className={clsx('global__text--subtitle')} dangerouslySetInnerHTML={{ __html: subtitle }} />}
      {hr && <hr />}
      {line && <div className="line" />}
      {children}
      {social && <SocialIcons />}
    </div>
  );
};

export default ContentHeader;

ContentHeader.propTypes = {
  header: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  social: PropTypes.bool,
  line: PropTypes.bool,
  hr: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  layout: PropTypes.oneOf(['', 'row', 'column']),
};

ContentHeader.defaultProps = {
  header: '',
  subtitle: '',
  children: null,
  social: false,
  line: false,
  hr: false,
  icon: null,
  layout: 'column',
};
